import React from 'react';
import { codeErrorResponse } from 'functions/codeError';
import ModalPortal from 'components/Modal';

export function ModalError(props) {
    const {
        errorCode,
        section,
        handleClose,
        message
    } = props;

    try{
        window.ineum('reportError', errorCode, {
            componentStack: errorCode?.codMen,
            meta: {
                widgetType: section,
                codeError: errorCode?.codMen,
                messError: message
            }
        });
    }catch(e){
        console.log('error: ', e)
    }

    return (
        <ModalPortal type="sinClose" onClose={handleClose} >
            {/* <p className='titleErrorModal'>Código de error: <span className='colorRojo bold'>{errorCode?.codMen}</span></p> */}
            <br />
            <p className='textcenter'>
                {!message
                    ? codeErrorResponse(errorCode?.codMen, section)
                    : message
                }
            </p>

            <div className="btnContinuarModal" onClick={handleClose}>
                <p>Aceptar</p>
            </div>
        </ModalPortal>
    )
}